import { dangerouslyLoadTrustedFormScript } from '@clearlink/emily'
import { MegaForm } from '@leshen/ui'
import { graphql, useStaticQuery } from 'gatsby'
import React, { useEffect } from 'react'

import { useMapi } from '../context/MapiProvider'
import MegaFormSubmissionMessage from './MegaForm/MegaFormSubmissionMessage'

import emilySubmit from './Form/utils'

const LeshenMegaForm = (props) => {
  const data = useStaticQuery(graphql`
    query MegaFormAddressQualQuery {
      site {
        siteMetadata {
          smartyStreetsWebsiteKey
          addressQualificationCode
        }
      }
    }
  `)

  const { smartyStreetsWebsiteKey, addressQualificationCode } =
    data.site.siteMetadata

  const mapiData = useMapi()

  useEffect(() => {
    dangerouslyLoadTrustedFormScript()
  }, [])

  return (
    <MegaForm
      onSubmit={emilySubmit}
      submissionData={mapiData}
      smartyStreetsWebsiteKey={smartyStreetsWebsiteKey}
      addressQualificationCode={addressQualificationCode}
      submissionMessage={<MegaFormSubmissionMessage />}
      {...props}
    />
  )
}

export default LeshenMegaForm
